export function exportToCSV(sessions, filename = 'historial.csv') {
  const rows = [['Fecha', 'Ejercicio', 'Serie', 'Peso (kg)', 'Reps', 'Completado']];

  sessions.forEach(session => {
    (session.exercises || []).forEach(ex => {
      (ex.sets || []).forEach(set => {
        rows.push([
          session.date || '',
          ex.exercise_name || '',
          set.set_number || '',
          set.weight ?? '',
          set.reps ?? '',
          set.completed ? 'Sí' : 'No',
        ]);
      });
    });
  });

  const csv = rows.map(r => r.map(c => {
    const str = String(c ?? '');
    return str.includes(',') || str.includes('"') ? `"${str.replace(/"/g, '""')}"` : str;
  }).join(',')).join('\n');

  const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
